import type { TranslationTemplate } from "../../../application.i18n";

export default {
	title: "Innstillinger",
	"search-sites": "Søk steder",
	"set-source": "Sett kilde",
	"set-source-for-selected-sites": "Sett kilde for {{num}} valgte steder",
	"select-all": "Velg alle",
	"no-table-rows": "Ingen resultater",
	"feed-plan": "Fôrplan",
	source: "Kilde",
	"previous-week-recommended": "Forrige uke anbefalt",
	"previous-week-actual": "Forrige uke faktisk",
	"this-week-recommended": "Denne uken anbefalt",
	"this-week": "Denne uken",
	manualplan: "Manuell plan",
	feedstation: "Fôrstasjon",
	farmer: "Bonde",
	"selected-source": "Valgt kilde",
	week: "Uke",
	total: "Totalt",
	"locales-update-failed": "Kunne ikke oppdatere språk",
	"locales-updated": "Språk oppdatert",
	"failed-to-update-settings": "Kunne ikke oppdatere innstillinger",
	"settings-updated": "Innstillinger oppdatert",
	admin: {
		"details-title": "Detaljer",
		environment: "Miljø",
		version: "Versjon",
		language: "Språk",
		"features-title": "Funksjoner",
		"feature-enabled": "Aktivert",
		"feature-disabled": "Deaktivert",
		theme: "Tema",
	},
	general: {
		selectLanguage: "Språk",
		selectTheme: "Tema",
		selectDecimalCount: "Antall desimaler",
	},
	liveConfigurations: {
		title: "Live konfigurasjoner",
		customizeView: "Tilpass visning",
		selectView: "Velg visning",
		defaultViewOption: "Visning: Standard",
		selectViewDescription:
			"Velg hvilke målestokk som skal vises i visningen og lagre endringene, eller lagre som en ny visning.",
		siteViewMode: {
			multiple: "Flere steder",
			single: "Enkelt sted",
			description:
				"Endringer vil påvirke visningen for enkelt sted. Gå til flersteds-fanen for å endre visningen for flere steder.",
		},
		feed: {
			title: "Fôrfremgang",
			description: "Velg hvordan du vil se fôrfremgang.",
			show: "Vis",
			checks: {
				intensity: "Intensitet",
				amount: "Mengde",
				target: "Mål",
			},
		},
		cardSection: {
			overview: {
				title: "Vis i toppseksjon",
				description:
					"Velg hvilke målestokk som skal vises i sammendraget i toppseksjonen og rekkefølgen de vises i.",
			},
			cards: {
				title: "Vis i kort",
				description: "Velg hvilke målestokk som skal vises i kortene og rekkefølgen de vises i.",
			},
		},
		actions: {
			resetChanges: "Tilbakestill endringer",
			saveAsNewView: "Lagre som ny visning",
			saveChangesToView: "Lagre endringer til visning",
		},
	},
	tabs: {
		general: "Generelt",
		"live-configurations": "Live konfigurasjoner",
		admin: "Admin",
	},
	language: {
		norwegian: "Norsk",
		english: "Engelsk",
	},
	theme: {
		light: "Lys",
		dark: "Mørk",
	},
} satisfies TranslationTemplate["SETTINGS"];
